import React, { useState } from 'react';
import styled from 'styled-components';

import {
  TextareaField,
  SelectField,
  PhoneField,
  TextField,
  OfficeField,
} from '~fields';

import TagActivationField from './TagActivationField';

import { FormLabel as Label, Gap } from '~ui-kit';

import { useOrganizationOptions, useUserOrganizationAsDefault } from '~hooks';
import { getBuildings } from '../../services/api.helpers';

const TagActivationForm = props => {
  const [buildingOptions, setBuildingOptions] = useState([]);

  const {
    formId,
    formik: { setFieldValue },
  } = props;

  const handleOfficeChange = async ({ value: officeId }) => {
    const buildings = await getBuildings(officeId);
    const buildingOptions = buildings.map(b => ({
      value: b.id,
      label: b.title,
    }));

    setBuildingOptions(buildingOptions);
  };

  const organizationOptions = useOrganizationOptions({ formId });
  useUserOrganizationAsDefault({
    organizations: organizationOptions,
    change: value => setFieldValue('organization', value),
  });

  return (
    <Container>
      <TagActivationField
        name="accessTagUsersAndNumbers"
        addLabel="Lisää uusi kulunvalvontatunniste"
        removeLabel="Poista"
        required
      />
      <SelectField name="organization" options={organizationOptions} required />
      <div>
        <Label>
          Tiedot kulunvalvontatunnisteelle tarvittavista oikeuksista
        </Label>
        <Permissions>
          <OfficeField
            name="office"
            flat
            required
            labelWidth="90px"
            onChange={handleOfficeChange}
          />
          <Gap height="16px" />
          <SelectField
            name="building"
            flat
            fallbackLabel="Rakennus"
            options={buildingOptions}
            required
            labelWidth="90px"
          />
          <Gap height="16px" />
          <TextField name="accessGroup" required />
          <Gap height="16px" />
          <TextareaField name="additionalRequirements" />
        </Permissions>
      </div>
      <PhoneField name="ordererPhone" required />
    </Container>
  );
};

const Container = styled.div`
  & > * {
    margin-bottom: 24px;
  }
`;

const Permissions = styled.div`
  background-color: #f0efef;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;

  // max-width: var(--field-width);
`;

export default TagActivationForm;
